<template>
  <div class="parklist">
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="a_name">停车道路：</label>
            <input
              v-model.trim="search.parkName"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addrOrEdit()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车场ID"
            prop="parkingId"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="类型"
            prop="parkingType"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="是否共享车位"
            prop="isShare"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.isShare == '1'">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="共享类型">
            <template slot-scope="scope">
              <span v-if="scope.row.isShare == '1'">
                {{
                  scope.row.attr2 == 1
                    ? "二类车场"
                    : scope.row.attr2 == 2
                    ? "一类车场"
                    : "未知类型"
                }}
              </span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="楼层"
            prop="floor"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="创建时间"
            prop="crtTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地址"
            prop="parkingAddress"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="车场图片" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.attr3" class="image-button-container">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture"
                  @click="previewParkingImage(scope.row.attr3)"
                  class="preview-image-btn"
                >
                  查看图片
                </el-button>
              </div>
              <span v-else class="no-image">暂无图片</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="500px">
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.parkingType == '路侧' ||
                  scope.row.parkingType == 'roadside'
                "
              >
                <button
                  class="code-download operate-button"
                  @click="
                    getChargeRule(scope.row.parkingId, scope.row.chargeRuleId)
                  "
                >
                  收费规则
                </button>
              </template>
              <button
                class="edit operate-button"
                type="button"
                @click="addrOrEdit(scope.row.parkingId)"
              >
                修改
              </button>

              <button
                class="delete operate-button"
                @click="delPark(scope.row.parkingId)"
                type="button"
              >
                删除
              </button>
              <button
                class="code-download operate-button"
                @click="payBind(scope.row.parkingId, scope.row.paymentChannel)"
                type="button"
              >
                支付绑定
              </button>
              <template
                v-if="
                  scope.row.parkingType == '室内' ||
                  scope.row.parkingType == 'onsite'
                "
              >
                <button
                  class="code-download operate-button"
                  @click="generateActivationCode(scope.row.parkingId)"
                  type="button"
                >
                  生成激活码
                </button>
                <button
                  class="code-download operate-button"
                  @click="viewActivationCode(scope.row.parkingId)"
                  type="button"
                >
                  查看激活码
                </button>
                <button
                  class="code-download operate-button"
                  @click="
                    codeDownload(scope.row.parkingId, scope.row.parkingName)
                  "
                  type="button"
                >
                  二维码
                </button>
              </template>
              <!-- <button
                class="delete operate-button"
                type="button"
                @click="configure(scope.row.parkingId)"
              >
                配置
              </button> -->
              <!-- <button
                class="code-download operate-button"
                @click="chargeLower"
                type="button"
              >
                计费规则下发
              </button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <Page v-on:pagination="receivePaginationData"></Page>

    <!-- 添加停车场 -->
    <el-dialog
      :close-on-click-modal="false"
      :lock-scroll="false"
      title="车场信息管理"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="closeDialogParking"
      class="parking-dialog-form"
    >
      <div class="parking-dialog-content">
        <!-- 左侧表单区域 -->
        <div class="form-section">
          <h3 class="section-title">基本信息</h3>
          <div class="form-tip">
            <i class="el-icon-info"></i>
            请填写车场的基本信息，带 <span class="required">*</span> 的为必填项
          </div>
          <el-form
            ref="form"
            label-position="top"
            :model="form"
            :rules="rules"
            :label-width="formLabelWidth"
            id="form"
            class="parking-form"
          >
            <div class="form-row">
              <el-form-item label="城市" prop="city" class="form-item-half">
                <el-select
                  @change="changeCity"
                  filterable
                  v-model.trim="form.city"
                  placeholder="请选择城市"
                  size="medium"
                >
                  <el-option
                    v-for="item in allCity"
                    :key="item.value"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="showCounty"
                label="县/区"
                prop="county"
                class="form-item-half"
              >
                <el-select
                  @change="changeCounty"
                  filterable
                  v-model.trim="form.county"
                  placeholder="请选择县/区"
                  size="medium"
                >
                  <el-option
                    v-for="item in allCounty"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item
                label="物业"
                prop="propertyId"
                class="form-item-half"
              >
                <el-select
                  class="check-property"
                  filterable
                  clearable
                  v-model.trim="form.propertyId"
                  placeholder="请选择物业"
                  size="medium"
                >
                  <el-option
                    v-for="item in propertyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="停车道路" prop="name" class="form-item-half">
                <el-input
                  v-model="form.name"
                  placeholder="请输入停车道路名称"
                  size="medium"
                ></el-input>
              </el-form-item>
            </div>

            <el-form-item label="地址" prop="address">
              <el-input
                readonly
                v-model="form.address"
                placeholder="点击地图选择地址"
                auto-complete="off"
                size="medium"
              ></el-input>
            </el-form-item>

            <div class="form-row">
              <el-form-item label="类型" class="form-item-half">
                <el-select
                  v-model="form.type"
                  placeholder="请选择类型"
                  size="medium"
                >
                  <el-option
                    v-for="item in allType"
                    :key="item.index"
                    :label="item.labelZhCh"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="免密支付" class="form-item-half">
                <div class="payment-checkbox">
                  <el-checkbox
                    v-model="form.unconsciousPayAuto"
                    false-label="1"
                    true-label="0"
                    class="checkbox-item-inline"
                  >
                    <i class="el-icon-credit-card payment-icon"></i>
                    <span class="checkbox-label">是否支持免密支付</span>
                  </el-checkbox>
                </div>
              </el-form-item>
            </div>

            <div class="share-section">
              <div class="share-header">
                <el-checkbox v-model="form.isShare" class="share-checkbox">
                  <i class="el-icon-share share-icon"></i>
                  <span class="share-label">是否共享车位</span>
                </el-checkbox>
              </div>
              <div class="share-content" v-if="form.isShare">
                <el-form-item label="共享类型" class="share-type-item">
                  <el-select
                    v-model="form.attr2"
                    placeholder="请选择共享类型"
                    size="medium"
                  >
                    <el-option
                      v-for="item in shareType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="楼层" class="floor-item">
                  <el-input
                    type="textarea"
                    v-model="form.parkingLayer"
                    placeholder="请输入楼层信息，用逗号分隔，例如：'一层，负一层，负二层'"
                    size="medium"
                 
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <el-form-item label="车场图片" class="full-width-item">
              <div class="image-upload-container">
                <div class="upload-section">
                  <el-upload
                    ref="parkingImageUpload"
                    class="avatar-uploader"
                    action="/api/tool/oss/upload"
                    :show-file-list="false"
                    :on-success="handleParkingImageSuccess"
                    :on-error="handleParkingImageError"
                    :on-change="beforeParkingImageUpload"
                    :on-progress="handleUploadProgress"
                    :auto-upload="true"
                    :before-upload="validateParkingImage"
                    :disabled="imageUploadLoading"
                  >
                    <div
                      v-if="imageUploadLoading"
                      class="upload-loading-overlay"
                    >
                      <i class="el-icon-loading"></i>
                      <span>上传中...</span>
                    </div>
                    <div v-else-if="parkingImageUrl" class="image-with-remove">
                      <img :src="parkingImageUrl" class="avatar" />
                      <!-- 漂浮的移除按钮 -->
                      <div class="floating-remove-btn">
                        <el-button
                          type="danger"
                          size="mini"
                          icon="el-icon-delete"
                          circle
                          @click.stop="removeParkingImage"
                          :disabled="isSubmitting"
                          class="remove-btn-circle"
                        ></el-button>
                      </div>
                    </div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip-below">
                    支持JPG、PNG格式，大小不超过2MB
                  </div>
                  <div v-if="imageUploadLoading" class="upload-progress">
                    <el-progress
                      :percentage="uploadProgress"
                      :stroke-width="4"
                      :show-text="false"
                      color="#409eff"
                    ></el-progress>
                    <span class="progress-text">{{ uploadProgress }}%</span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>

        <!-- 右侧地图区域 -->
        <div class="map-section">
          <h3 class="section-title">位置选择</h3>
          <div class="map-tip">
            <i class="el-icon-location"></i>
            点击地图选择具体位置，或输入地址搜索定位
          </div>
          <div class="map-container">
            <div class="address-search">
              <el-input
                v-model="searchAddress"
                placeholder="请输入地址进行定位"
                size="medium"
                class="search-input"
                @keyup.enter.native="searchMapAddress"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchMapAddress"
                ></el-button>
              </el-input>
            </div>
            <div id="areaMap" class="map-content"></div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="addrOrEditTrue"
          :loading="isSubmitting"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? "提交中..." : "确 定" }}
        </el-button>
        <el-button @click="onParkCancleBtn" :disabled="isSubmitting"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 设置收费规则     -->
    <el-dialog
      :close-on-click-modal="false"
      :lock-scroll="false"
      title="收费规则"
      :visible.sync="dialogFormVisibleRule"
      :width="chargeRuldeMode === '1' ? '800px' : '1350px'"
      @open="openDialogRule"
      @close="closeDialogRule"
      :fullscreen="true"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <el-form-item label="收费模式" prop class="chargerule-mode">
            <el-col :span="18">
              <template>
                <el-select
                  filterable
                  v-model="chargeRuldeMode"
                  placeholder="请选择"
                  @change="getChargeRuleMode"
                >
                  <el-option
                    v-for="item in allChargeRuleTypeData"
                    :key="item.value"
                    :label="item.labelDefault"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-col>
          </el-form-item>
          <!--按小时收费-->
          <template v-if="showTimeAdd">
            <div class="columns">
              <el-form-item label="免费停车时长" prop="freeParking">
                <el-input v-model="ruleForm.freeParking"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <!-- <el-form-item label="最高限额：" prop="ceiling">
                <el-input v-model="ruleForm.ceiling"></el-input>
                <p class="position">元</p>
              </el-form-item> -->
            </div>
            <el-form-item label="起始时间" prop="beginTime">
              <el-time-picker
                v-model="ruleForm.beginTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="end">
              <el-time-picker
                v-model="ruleForm.end"
                value-format="HH:mm"
                :picker-options="{ minTime: 'ruleForm.beginTime' }"
                format="HH:mm"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>
            <div class="columns limit">
              <el-form-item class="limit-tip" label="最高限额:"> </el-form-item>
              <el-form-item label="小车" label-width="40px">
                <el-input
                  v-model="ruleForm.ceiling"
                  style="width: 55px"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="大车">
                <el-input v-model="ruleForm.attr5"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="超大车">
                <el-input v-model="ruleForm.attr6"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label="首段时长">
                <el-input v-model="ruleForm.money1"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="(小车)收费">
                <el-input v-model="ruleForm.money2"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(大车)收费">
                <el-input v-model="ruleForm.attr1"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(超大车)收费">
                <el-input v-model="ruleForm.attr3"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label="超首段时长后每">
                <el-input v-model="ruleForm.money3"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="(小车)收费">
                <el-input v-model="ruleForm.money4"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(大车)收费">
                <el-input v-model="ruleForm.attr2"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(超大车)收费">
                <el-input v-model="ruleForm.attr4"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
          </template>
          <!--按时段收费-->
          <template v-if="showPeriod">
            <div class="columns">
              <el-form-item label="免费停车时长" prop="freeParking">
                <el-input v-model="periodRule.freeParking"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="最高限额" prop="ceiling">
                <el-input v-model="periodRule.ceiling"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <el-form-item label="起始时间" prop="beginTime">
              <el-time-picker
                v-model="periodRule.beginTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="end">
              <el-time-picker
                v-model="periodRule.end"
                value-format="HH:mm"
                :picker-options="{ minTime: 'periodRule.beginTime' }"
                format="HH:mm"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>

            <div class="columns">
              <el-form-item label="首段时长:">
                <el-input v-model="periodRule.money1"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="(小车)收费">
                <el-input v-model="periodRule.money2"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(大车)收费">
                <el-input v-model="periodRule.attr1"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(超大车)收费">
                <el-input v-model="periodRule.attr3"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>

            <div class="period-group">
              <div
                class="columns"
                v-for="period in periodRule.periods"
                :key="period.id"
              >
                <el-form-item label="超过:">
                  <el-input v-model="period.exceed"></el-input>
                  <p class="position">分钟</p>
                </el-form-item>
                <el-form-item label="每">
                  <el-input v-model="period.every"></el-input>
                  <p class="position">分钟</p>
                </el-form-item>
                <el-form-item label="(小车)收费">
                  <el-input v-model="period.car"></el-input>
                  <p class="position">元</p>
                </el-form-item>
                <el-form-item label="(大车)收费">
                  <el-input v-model="period.cart"></el-input>
                  <p class="position">元</p>
                </el-form-item>
                <el-form-item label="(超大车)收费">
                  <el-input v-model="period.superCar"></el-input>
                  <p class="position">元</p>
                </el-form-item>
                <div class="reduce" v-if="periodRule.periods.length > 1">
                  <i
                    class="el-icon-remove-outline"
                    @click="onRuleReduceClick(period.id)"
                  ></i>
                </div>
              </div>
            </div>
            <div class="add">
              <i
                class="el-icon-circle-plus-outline"
                @click="onRuleAddClick"
              ></i>
            </div>
          </template>
          <!--按工作日/非工作日计费-->
          <template v-if="showTimeQuantum">
            <div class="size">
              <span>工作日收费：</span>
            </div>
            <div class="columns columns-others">
              <el-form-item label="免费停车时长：" prop="freeParking">
                <el-input v-model="formRuleOne.freeTime"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <!-- <el-form-item label="最高限额：" prop="ceiling">
                <el-input v-model="formRuleOne.params[0].wdLastPrice"></el-input>元
              </el-form-item>-->
            </div>
            <!-- <el-form-item label="起止时间：" prop="startingAndEndF"> -->
            <!-- <el-time-select
                placeholder="起始时间"
                v-model="formRuleOne.params[0].wdStartOrEndTime[0]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00'
              }"
              ></el-time-select>
              <el-time-select
                placeholder="结束时间"
                v-model="formRuleOne.params[0].wdStartOrEndTime[1]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00',
              }"
            ></el-time-select>-->
            <el-form-item label="起止时间：" prop="wdStartOrEndTime">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.wdStartOrEndTime"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="起止时间：" prop="wdStartOrEndTimeEnd">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{ minTime: 'ruleForm.wdStartOrEndTime' }"
                v-model="ruleForm.wdStartOrEndTimeEnd"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>
            <div class="columns">
              <el-form-item label="首段时长:">
                <el-input
                  v-model="formRuleOne.params[0].wdAfterHourF"
                ></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].wdFirstPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns column-last">
              <!-- <el-form-item label="超首段时长后每">
                  <el-input v-model="ruleForm.money3" ></el-input>分钟
                </el-form-item>
              <el-form-item label="收费">
                  <el-input v-model="ruleForm.money4" ></el-input>元
              </el-form-item>-->
              <el-form-item>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].wdAfterHourF"
                ></el-input
                >-
                <el-input v-model="formRuleOne.params[0].wdLastHour"></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].wdAfterPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].wdLastHour"
                ></el-input>
                <p class="position">小时后,</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].wdLastPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="size">
              <span>非工作日收费：</span>
            </div>
            <div class="columns columns-others">
              <el-form-item label="免费停车时长：" prop="freeParkingF">
                <el-input v-model="formRuleOne.freeTime"></el-input>
                <p class="position">分钟</p>
              </el-form-item>

              <!-- <el-form-item label="最高限额：" prop="ceilingF">
                <el-input v-model="formRuleOne.params[0].odLastPrice"></el-input>元
              </el-form-item>-->
            </div>

            <!-- <el-form-item label="起止时间：" prop="startingAndEndF"> -->
            <!-- <el-time-select
                placeholder="起始时间"
                v-model="formRuleOne.params[0].odStartOrEndTime[0]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00'
              }"
              ></el-time-select>
              <el-time-select
                placeholder="结束时间"
                v-model="formRuleOne.params[0].odStartOrEndTime[1]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00',
                minTime:ruleForm.beginTimeF
              }"
            ></el-time-select>-->
            <el-form-item label="起止时间：" prop="odStartOrEndTime">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.odStartOrEndTime"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="起止时间：" prop="odStartOrEndTimeEnd">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{ minTime: 'ruleForm.odStartOrEndTime' }"
                v-model="ruleForm.odStartOrEndTimeEnd"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>
            <div class="columns">
              <el-form-item label="首段时长：" prop="firstTime">
                <el-input
                  v-model="formRuleOne.params[0].odAfterHourF"
                ></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费" prop="firstTime">
                <el-input
                  v-model="formRuleOne.params[0].odFirstPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns column-last">
              <!-- <el-form-item label="超首段时长后每">
                  <el-input v-model="ruleForm.moneyF3" ></el-input>分钟
                </el-form-item>
              <el-form-item label="收费">
                  <el-input v-model="ruleForm.moneyF4" ></el-input>元
              </el-form-item>-->
              <el-form-item>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].odAfterHourF"
                ></el-input
                >-
                <el-input v-model="formRuleOne.params[0].odLastHour"></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].odAfterPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].odLastHour"
                ></el-input>
                <p class="position">小时后,</p>
              </el-form-item>
              <el-form-item label="收费" prop="firstTime">
                <el-input v-model="formRuleOne.params[0].odLastPrice"></el-input
                >元
              </el-form-item>
            </div>
          </template>
          <template v-if="showTimeAdd">
            <div class="gap"></div>
            <div class="columns discount">
              <el-form-item
                label="小车新能源打折"
                label-width="130px"
                class="car-discount"
              >
                <el-input v-model="ruleForm.smallDiscount"></el-input>
                <span class="discount-tip">0-100</span>
              </el-form-item>
              <el-form-item
                label="小车新能源每日优惠时长"
                label-width="220px"
                class="car-discount"
              >
                <el-input v-model="ruleForm.smallDiscountHours"></el-input>
                <span class="discount-tip">小时</span>
              </el-form-item>
              <el-form-item class="car-discount" label-width="40px">
                <el-checkbox
                  name="type"
                  v-model="ruleForm.smallByparkFlag"
                ></el-checkbox>
                <span class="discount-tip">小车新能源按每个道路优惠方式</span>
              </el-form-item>
            </div>
            <div class="columns discount">
              <el-form-item
                label="大车新能源打折"
                label-width="130px"
                class="car-discount"
              >
                <el-input v-model="ruleForm.bigDiscount"></el-input>
                <span class="discount-tip">0-100</span>
              </el-form-item>
              <el-form-item
                label="大车新能源每日优惠时长"
                label-width="220px"
                class="car-discount"
              >
                <el-input v-model="ruleForm.bigDiscountHours"></el-input>
                <span class="discount-tip">小时</span>
              </el-form-item>
              <el-form-item class="car-discount" label-width="40px">
                <el-checkbox
                  name="type"
                  v-model="ruleForm.bigByparkFlag"
                ></el-checkbox>
                <span class="discount-tip">大车新能源按每个道路优惠方式</span>
              </el-form-item>
            </div>
            <div class="columns discount">
              <el-form-item
                label="超大车新能源打折"
                class="car-discount"
                label-width="130px"
              >
                <el-input v-model="ruleForm.overbigDiscount"></el-input>
                <span class="discount-tip">0-100</span>
              </el-form-item>
              <el-form-item
                label="超大车新能源每日优惠时长"
                label-width="220px"
                class="car-discount"
              >
                <el-input v-model="ruleForm.overbigDiscountHours"></el-input>
                <span class="discount-tip">小时</span>
              </el-form-item>
              <el-form-item class="car-discount" label-width="40px">
                <el-checkbox
                  name="type"
                  v-model="ruleForm.overbigByparkFlag"
                ></el-checkbox>
                <span class="discount-tip">超大车新能源按每个道路优惠方式</span>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addrOrEditRuleTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleRule = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 选择巡检员 -->
    <el-dialog
      title="选择巡检员"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="outerCodeDialogVisible"
    >
      <el-radio-group
        v-model="codeDownloadData.chargeUserId"
        @change="selectedChargerUser"
      >
        <el-radio
          v-for="item in allChargeUserData"
          :label="item.id"
          :key="item.id"
          >{{ item.username }}</el-radio
        >
      </el-radio-group>
    </el-dialog>
    <!--下载二维码-->
    <el-dialog
      title="下载二维码"
      :close-on-click-modal="false"
      :visible.sync="codeDialogVisible"
      :lock-scroll="false"
    >
      <table class="table">
        <thead>
          <tr>
            <td>二维码边长(cm)</td>
            <td>建议扫描距离(米)</td>
            <td>下载链接</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>8cm</td>
            <td>0.5m</td>
            <td @click="downloadQrcode(258, 258)">
              <button class="code-download">下载</button>
            </td>
          </tr>
          <tr>
            <td>15cm</td>
            <td>1m</td>
            <td @click="downloadQrcode(430, 430)">
              <button class="code-download">下载</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="qrcode"></div>
    </el-dialog>

    <!--支付绑定-->
    <el-dialog
      title="绑定支付方式"
      :visible.sync="payTypeDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-radio-group v-model="payTypeForm.payType" @change="hasPayConfigure">
        <el-radio
          v-for="item in allPayTypeData"
          :label="item.value"
          :key="item.id"
          >{{ item.labelDefault }}</el-radio
        >
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payBindTrue">确 定</el-button>
        <el-button @click="payTypeDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--激活码-->
    <el-dialog
      title="激活码"
      :visible.sync="activationCodeDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form
        class="fl"
        ref="form"
        label-position="right"
        :model="activationCodeForm"
        :label-width="formLabelWidth"
        id="form"
      >
        <el-form-item label="设备标识" prop>
          <el-col :span="18">
            <el-input v-model="activationCodeForm.udId"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="类型" prop>
          <el-col :span="18">
            <el-select
              filterable
              v-model="activationCodeForm.type"
              placeholder="请选择"
              @change="getActivationCodeType"
            >
              <el-option
                v-for="item in allActivationType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-show="dateView" label="开始时间" prop>
          <el-col :span="18">
            <el-date-picker
              v-model="activationCodeForm.begindate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item v-show="dateView" label="结束时间" prop>
          <el-col :span="18">
            <el-date-picker
              v-model="activationCodeForm.enddate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generateActivationCodeTrue"
          >确 定</el-button
        >
        <el-button @click="activationCodeDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!--激活码列表-->
    <el-dialog
      title="激活码列表"
      :visible.sync="viewActivationCodeDialogVisible"
      width="80%"
      :lock-scroll="false"
      @open="viewActivationCodeList"
    >
      <el-table border :data="activationCodeData">
        <el-table-column show-overflow-tooltip label="停车场">
          <template slot-scope="scope">{{
            scope.row.parkingId ? JSON.parse(scope.row.parkingId).name : ""
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="设备标识符"
          prop="udId"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="类型">
          <template slot-scope="scope">{{
            scope.row.type == 1 ? "永久" : "起止时间"
          }}</template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="激活码"
          prop="activationCode"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="开始时间"
          prop="begindate"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="结束时间"
          prop="enddate"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <!--配置 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="配置"
      :visible.sync="dialogConfigureVisible"
      width="500px"
      @open="openConfigureDialog"
      @close="closeConfigureDialog"
    >
      <ul>
        <li v-for="item in configureData" :key="item.id">
          <span class="configure-message">{{ item.labelDefault }}(单选)：</span>
          <span
            class="configure-message"
            @click="clickItemConfigure(item, 'open')"
          >
            启用
            <template>
              <img
                v-if="item.isOpen"
                width="10px"
                src="@/assets/images/click.png"
              />
              <img v-else width="10px" src="@/assets/images/unclick.png" />
            </template>
          </span>
          <span
            class="configure-message"
            @click="clickItemConfigure(item, 'close')"
          >
            关闭
            <template>
              <img
                v-if="item.isClose"
                width="10px"
                src="@/assets/images/click.png"
              />
              <img v-else width="10px" src="@/assets/images/unclick.png" />
            </template>
          </span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="configureOneConfigure"
          >确 定</el-button
        >
        <el-button @click="dialogConfigureVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  chargeUserList,
  addOrEdit,
  getAllPayType,
  getActivationCodeList,
  getPayConfigure,
  getParkingType,
  refreshToken,
  getAllParkingsByEnabled,
  getParkSingle,
  getChargeRuleF,
  parkingBusType,
  dictValue,
  getCity,
  parkList,
  getRulesType,
  addOrUpdateChargeRule,
  getChargeRule,
  deletePark,
  parkAdd,
  addMapOverlay,
  getManagerList,
  getAllCounty,
  requestAllChargeRuleType,
  addOrUpdateChargeRuleByTimeQuantum,
  getChargeRuleByTimeQuantum,
  requestParkingBaseConfig,
  getOneParkingConfigure,
  requestConfigureOneParkingConfigure,
  getGenerateActivationCode,
  fetchPropertyList,
} from "@/api/url";

import Page from "../../commons/page.vue";

import Refresh from "../../commons/refresh.vue";

import AllTree from "../../commons/allTree.vue";

import Cookies from "js-cookie";

import QRCode from "qrcodejs2"; // 引入qrcode

// 导入天地图工具函数
import {
  waitForTiandituAPI,
  createTiandituMap,
  setMapEvent,
  addMapControl,
  addMapOverlayl,
  reverseGeocode,
  geocodeAddress,
  setMapCenter,
} from "@/utils/tianditu";

const strToNumber = function (str) {
  if (typeof Number(str) === "number") return Number(str);
  return 0;
};
export default {
  data() {
    return {
      imageUploadLoading: false, // 图片上传loading
      uploadProgress: 0, // 上传进度
      // invoiceChecked: "",
      shareType: [
        {
          label: "二类车场", //企业车位
          value: "1",
        },
        {
          label: "一类车场", //个人车位
          value: "2",
        },
      ],
      propertyList: [],
      configureForm: {
        parkingId: "",
        code: [],
      },
      baseConfigureData: [],
      configureData: [], //用户配置数据
      menuKey: 1,
      dialogConfigureVisible: false, //配置
      isOpen: false, //配置
      isClose: false, //配置
      parklist_btn_add: false,
      parklist_btn_rule: false,
      parklist_btn_pkset: false,
      parklist_btn_control: false,
      parklist_btn_person: false,
      parkset_btn_edit: false,
      parklist_btn_remove: false,
      codeDialogVisible: false,
      activationCodeDialogVisible: false,
      viewActivationCodeDialogVisible: false,
      showTimeQuantum: false,
      showTimeAdd: true,
      showPeriod: false,
      dateView: false,
      payTypeDialogVisible: false,
      allPayTypeData: [],
      allChargeRuleTypeData: [],
      allChargeUserData: [],
      outerCodeDialogVisible: false,
      showCounty: false,
      codeDownloadData: {
        parkingId: "",
        parkingName: "",
        chargeUserId: "",
      },
      activationCodeForm: {
        parkingId: "",
        udId: "",
        type: "",
        begindate: "",
        enddate: "",
      },
      activationCodeData: [],
      allActivationType: [
        { name: "永久", value: 1 },
        { name: "起止时间", value: 2 },
      ],
      payTypeForm: {
        payType: "",
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parentId: "",
      },

      moduleName: "parking",
      form: {
        id: "",
        name: "",
        type: "roadside",
        city: "",
        scenImgUrl: "",
        address: "",
        longitude: "",
        latitude: "",
        manager: "",
        parkingBusType: "",
        county: "",
        propertyId: null,
        isShare: false,
        attr2: "", // 共享类型
        floor: "", // 楼层
        unconsciousPayAuto: 1,
        attr3: "", // 车场图片URL
        parkingLayer: "",
      },
      parkingImageUrl: "", // 车场图片预览URL
      isSubmitting: false, // 提交状态
      enabledFlag: "n",
      search: {
        pageNumber: 1,
        pageSize: 10,
        parkName: null,
        propertyId: null,
      },
      chargeRuldeMode: "4",
      //按时累加
      ruleForm: {
        chargeId: "",
        parkingId: "",
        chargeRuleId: "",
        freeParking: "",
        ceiling: "",
        startingAndEnd: "",
        beginTime: "",
        end: "",
        money1: "",
        money2: "",
        money3: "",
        money4: "",
        freeParkingF: "",
        ceilingF: "",
        startingAndEndF: "",
        beginTimeF: "",
        endF: "",
        moneyF1: "",
        moneyF2: "",
        moneyF3: "",
        moneyF4: "",
        attr1: "",
        attr2: "",
        attr3: "",
        attr4: "",
        attr5: "",
        attr6: "",
        wdStartOrEndTime: "",
        wdStartOrEndTimeEnd: "",
        odStartOrEndTime: "",
        odStartOrEndTimeEnd: "",
        smallDiscount: "",
        smallDiscountHours: "",
        smallByparkFlag: false,
        bigDiscount: "",
        bigDiscountHours: "",
        bigByparkFlag: false,
        overbigDiscount: "",
        overbigDiscountHours: "",
        overbigByparkFlag: false,
      },
      //按工作日/非工作日收费
      //室外1
      formRuleOne: {
        chargeRuleId: "",
        parkingId: "",
        freeTime: "",
        params: [
          {
            lrId: "",
            carType: "auto",
            // wdStartTime:
            //   _this.formRuleOne.params[0].wdStartOrEndTime[0],
            // wdEndTime: _this.formRuleOne.params[0].wdStartOrEndTime[1],
            wdStartOrEndTime: "",
            wdStartOrEndTimeEnd: "",
            wdAfterHourF: "",
            wdLastHour: "",
            wdFirstPrice: "",
            wdAfterPrice: "",
            wdLastPrice: "",
            wdFreeMin: "",
            // odStartTime:
            //   _this.formRuleOne.params[0].odStartOrEndTime[0],
            // odEndTime: _this.formRuleOne.params[0].odStartOrEndTime[1],
            odStartOrEndTime: "",
            odStartOrEndTimeEnd: "",
            odAfterHourF: "",
            odLastHour: "",

            odFirstPrice: "",
            odAfterPrice: "",
            odLastPrice: "",
            odFreeMin: "",
          },
        ],
      },
      //按时段收费
      periodRule: {
        chargeId: "",
        parkingId: "",
        chargeRuleId: "",
        freeParking: "",
        ceiling: "",
        startingAndEnd: "",
        beginTime: "",
        end: "",
        money1: "",
        money2: "",
        money3: "",
        money4: "",
        attr1: "",
        attr2: "",
        attr3: "",
        attr4: "",
        periods: [
          {
            id: Math.random().toString(16).slice(2),
            exceed: "",
            every: "",
            car: "",
            cart: "",
            superCar: "",
          },
        ],
      },
      tableListData: {
        rows: [],
      },
      tableListDataExcel: {},
      tableListDataAll: {},
      downloadFileds: {
        停车场: "parkingName",
        类型: {
          field: "parkingType",
          callback: (value) => {
            return value == "roadside" ? "室外" : "室内";
          },
        },
        // '管理员':'username',
        创建时间: "crtTime",
        地址: "parkingAddress",
      },
      formLabelWidth: "100px",
      dialogFormVisible: false,
      allParkingBusType: [],
      allType: [
        {
          labelZhCh: "室内",
          value: "onsize",
        },
        {
          labelZhCh: "路侧",
          value: "roadside",
        },
      ],
      allCity: [],
      allCounty: [],
      allManager: [],
      allChargeRule: [],
      allChargeRuleSel: [
        {
          name: "室内",
          id: "3",
        },
        {
          name: "路侧",
          id: "1",
        },
      ],
      rules: {
        beginTime: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        end: [{ required: true, message: "请输入结束时间", trigger: "blur" }],
        beginTimeF: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        endF: [{ required: true, message: "请输入结束时间", trigger: "blur" }],
        wdStartOrEndTime: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        wdStartOrEndTimeEnd: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],

        odStartOrEndTime: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        odStartOrEndTimeEnd: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],
        city: [
          {
            required: true,
            message: "请选择城市",
            trigger: ["blur", "change"],
          },
        ],
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          { required: true, message: "请填写车场名称", trigger: "blur" },
          // { min: 2, max: 8, message: "长度在 2 到 8 个字符", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请在地图上选取位置", trigger: "blur" },
        ],
      },
      map: {},

      dialogFormVisibleRule: false,
      searchAddress: "", // 地图搜索输入
    };
  },
  filters: {
    handelParkingType(value) {
      let d = "";
      switch (value) {
        case "roadside":
          d = "路边";
          break;
        case "onsite":
          d = "室内";
          break;
        default:
          break;
      }
      return d;
    },
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    changeCity: function (val) {
      this.form.county = "";
      let obj = {};
      obj = this.allCity.find((item) => {
        return item.id === val;
      });
      if (obj && obj.name) {
        // 如果地图已初始化，使用地理编码定位城市
        if (this.map) {
          geocodeAddress(obj.name, (result) => {
            if (result && result.lng && result.lat) {
              setMapCenter(this.map, result.lng, result.lat, 12);
              // 如果表单中没有地址，可以更新地址信息
              if (!this.form.address && !this.form.longitude) {
                this.form.address = obj.name;
                this.searchAddress = obj.name;
                this.form.longitude = result.lng;
                this.form.latitude = result.lat;
                addMapOverlayl(result.lat, result.lng, this.map);
              }
            }
          });
        }
      }
      this.getCounty(val);
    },
    changeCounty(val) {
      let obj = {};
      obj = this.allCounty.find((item) => {
        return item.id === val;
      });
      if (obj && obj.name) {
        // 如果地图已初始化，使用地理编码定位县/区
        if (this.map) {
          geocodeAddress(obj.name, (result) => {
            if (result && result.lng && result.lat) {
              setMapCenter(this.map, result.lng, result.lat, 14);
              // 如果表单中没有地址，可以更新地址信息
              if (!this.form.address && !this.form.longitude) {
                const cityName = this.allCity.find(c => c.id === this.form.city)?.name || '';
                const fullAddress = cityName ? `${cityName}${obj.name}` : obj.name;
                this.form.address = fullAddress;
                this.searchAddress = fullAddress;
                this.form.longitude = result.lng;
                this.form.latitude = result.lat;
                addMapOverlayl(result.lat, result.lng, this.map);
              }
            }
          });
        }
      }
    },
    handleKeyup: function (e) {
      e.target.value = e.target.value.replace(
        /[ !`~\!@#\$%\^&\*()_+=\-\;\:\"\'\\/?,<>|\A-Za-z\u4e00-\u9fa5]+/g,
        ""
      );
    },
    handleAfterpaste: function (e) {
      e.target.value = e.target.value.replace(
        /[ !`~\!@#\$%\^&\*()_+=\-\;\:\"\'\\/?,<>|\A-Za-z\u4e00-\u9fa5]+/g,
        ""
      );
    },
    handleKeyupTime: function (e) {
      e.target.value = e.target.value.replace(/\D/g, "");
    },
    handleAfterpasteTime: function (e) {
      e.target.value = e.target.value.replace(/\D/g, "");
    },
    getParkType: function () {
      this.$get(dictValue() + "/parking_type").then((data) => {
        this.allType = data.data.rows;
      });
    },
    getParkingBusType: function () {
      this.$get(parkingBusType()).then((data) => {
        this.allParkingBusType = data;
      });
    },
    getCity: function () {
      this.$get(getCity(), {
        arealevel: "2",
        name: "",
        limit: "0",
      }).then((data) => {
        if (data.status != 200) return;
        this.allCity = data.data.rows;
      });
    },
    getCounty(val) {
      this.$get(getAllCounty(), {
        arealevel: "3",
        limit: "0",
        parentId: val,
      }).then((data) => {
        if (data.status != 200) {
          return _this.$layer.msg(data.message);
        }
        this.allCounty = data.data.rows;
      });
    },

    
    getRulesType: function () {
      this.$get(getRulesType()).then((data) => {
        // if(data.status!=200) return;
        this.allChargeRule = data;
      });
    },
    //下载所有车场的数据
    tableListAll: function () {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);

        this.tableListDataAll = data.data;
      });
    },
    tableList: function (curPage) {
      var _this = this;
      const { parkName, propertyId } = this.search;
      this.$get(parkList(), {
        parkingName: parkName ? parkName : null,
        parentId: propertyId ? propertyId : null,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);

        const {
          data: { rows },
        } = data;
        _this.tableListData.rows = rows.map((item) => {
          if (item.parentId) {
            item.propertyName = JSON.parse(item.parentId).name;
          }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    searchList: function () {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },

    toView: function (parkId, parkName) {
      this.storageScenId(parkId);
      this.$router.push({
        path: "/main/park/parkset",
        query: { id: parkId, name: parkName },
      });
    },
    toStaff: function (parkId, parkName) {
      this.storageScenId(parkId);
      this.$router.push({
        path: "/main/park/staff",
        query: { id: parkId, name: parkName },
      });
    },
    getPropertyId(id) {
      this.form.propretyId = id;
    },
    addrOrEdit: async function (id) {
      this.dialogFormVisible = true;

      // 如果是编辑模式，先获取数据
      if (Boolean(id)) {
        this.showCounty = false;
        this.$postRequest(getParkSingle(), { parkingId: id })
          .then((data) => {
            if (data.status != 200) {
              return this.$layer.msg(data.message);
            }
            this.form.id = data.data.parkingId;
            this.form.name = data.data.parkingName;
            this.form.type = data.data.parkingType;
            this.form.city = data.data.cityId;
            this.form.address = data.data.parkingAddress;
            this.searchAddress = data.data.parkingAddress;
            this.form.latitude = data.data.pointLat;
            this.form.longitude = data.data.pointLng;
            this.form.manager = data.data.userId;
            this.form.chargeRuleId = data.data.chargeRuleId;
            this.form.parkingBusType = data.data.parkingBusType;
            this.form.propertyId = data.data.parentId;
            this.form.isShare = data.data.isShare == 1 ? true : false;
            this.form.attr2 = data.data.attr2 || "";
            this.form.floor = data.data.floor || "";
            this.form.unconsciousPayAuto = data.data.unconsciousPayAuto;
            this.form.attr3 = data.data.attr3 || "";
            this.parkingImageUrl = data.data.attr3 || "";
            this.form.parkingLayer = data.data.parkingLayer || "";

            // 调试信息
            console.log("编辑车场数据:", {
              isShare: this.form.isShare,
              attr2: this.form.attr2,
              originalData: data.data,
            });
            this.getCounty(this.form.city);
            
            // 初始化地图（编辑模式，有坐标）
            this.initMap(data.data.pointLng, data.data.pointLat, 16);
          })
          .catch(() => {
            // 即使获取数据失败，也初始化地图
            this.initMap();
          });
      } else {
        // 添加模式，重置表单
        this.showCounty = true;
        this.allCounty = "";
        this.form.id = "";
        this.form.name = "";
        this.form.city = "";
        this.form.county = "";
        this.form.address = "";
        this.searchAddress = "";
        this.form.latitude = "";
        this.form.longitude = "";
        this.form.manager = "";
        this.form.parkingBusType = "";
        this.form.isShare = false;
        this.form.attr2 = "";
        this.form.floor = "";
        this.form.unconsciousPayAuto = 1;
        this.form.parkingLayer = "";
        this.form.attr3 = "";
        this.parkingImageUrl = "";
        
        // 初始化地图（添加模式，默认位置）
        this.initMap();
      }
    },

    // 初始化地图
    initMap: async function (centerLng, centerLat, zoom) {
      this.$nextTick(async () => {
        try {
          // 等待天地图API加载完成
          await waitForTiandituAPI();
          
          // 如果已有地图实例，先清理
          if (this.map) {
            try {
              // 清除所有覆盖物
              const overlays = this.map.getOverlays ? this.map.getOverlays() : [];
              overlays.forEach(overlay => {
                if (this.map.removeOverlay) {
                  this.map.removeOverlay(overlay);
                }
              });
            } catch (e) {
              console.warn("清理地图覆盖物失败:", e);
            }
          }
          
          // 确定地图中心点和缩放级别
          const defaultLng = centerLng || this.form.longitude || 113.937122;
          const defaultLat = centerLat || this.form.latitude || 22.542874;
          const defaultZoom = zoom || (centerLng && centerLat ? 16 : 12);
          
          // 创建天地图实例
          const map = createTiandituMap("areaMap", {
            centerLng: defaultLng,
            centerLat: defaultLat,
            zoom: defaultZoom
          });

          if (!map) {
            this.$message.error("地图初始化失败，请刷新页面重试");
            return;
          }

          this.map = map;
          
          // 设置地图事件
          setMapEvent(map);
          
          // 添加地图控件
          addMapControl(map);
          
          var _this = this;
          
          // 地图点击事件 - 使用天地图API
          map.addEventListener("click", function (e) {
            // 获取点击的经纬度
            const lng = e.lnglat.lng || e.lnglat.getLng();
            const lat = e.lnglat.lat || e.lnglat.getLat();
            
            // 逆地理编码 - 根据坐标获取地址
            reverseGeocode(lng, lat, function (result) {
              if (result && result.address) {
                _this.form.address = result.address;
                _this.searchAddress = result.address;
                _this.form.longitude = lng;
                _this.form.latitude = lat;
                addMapOverlayl(lat, lng, _this.map);
              } else {
                // 即使没有地址，也保存坐标
                _this.form.longitude = lng;
                _this.form.latitude = lat;
                _this.form.address = `${lat}, ${lng}`;
                _this.searchAddress = `${lat}, ${lng}`;
                addMapOverlayl(lat, lng, _this.map);
              }
            });
          });
          
          // 如果是编辑模式且有坐标，添加标记点
          if (centerLng && centerLat) {
            setTimeout(() => {
              if (this.map) {
                addMapOverlayl(centerLat, centerLng, this.map);
                setMapCenter(this.map, centerLng, centerLat, defaultZoom);
              }
            }, 300);
          } else if (this.form.longitude && this.form.latitude) {
            // 如果表单中有坐标，也添加标记点
            setTimeout(() => {
              if (this.map) {
                addMapOverlayl(this.form.latitude, this.form.longitude, this.map);
                setMapCenter(this.map, this.form.longitude, this.form.latitude, 16);
              }
            }, 300);
          }
        } catch (error) {
          console.error("地图初始化错误:", error);
          this.$message.error("地图初始化失败，请刷新页面重试");
        }
      });
    },

    addrOrEditTrue: function () {
      var _this = this;
      if (this.uploadProgress > 0 && this.uploadProgress < 100) {
        return this.$layer.msg("图片正在上传，请稍后");
      }
      this.$refs["form"].validate(async function (valid, noStri) {
        if (valid) {
          _this.isSubmitting = true;
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(parkAdd(), {
                parentId: _this.form.propertyId,
                // parkingId: _this.form.id,
                parkingType: _this.form.type,
                cityId: _this.form.city,
                parkingAddress: _this.form.address,
                parkingName: _this.form.name,
                pointLat: _this.form.latitude,
                pointLng: _this.form.longitude,
                userId: _this.form.manager,
                attr2: _this.form.attr2,
                floor: _this.form.floor,
                // chargeRuleId: _this.form.chargeRuleId,
                attr3: _this.form.attr3,
                parkingBusType: _this.form.parkingBusType,
                isShare: _this.form.isShare ? 1 : 0,
                unconsciousPayAuto: _this.form.unconsciousPayAuto,
                parkingLayer: _this.form.parkingLayer?_this.form.parkingLayer.replace(/，/g, ',') : '',
                /*parkingBusModel:"1",
							parkingDescription:"selfSupport",
							parkingBusType: "1",
							approachNum:0,*/
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.isSubmitting = false;
                  return _this.$layer.msg(data.message);
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.search.pageNumber = 1;
                _this.initForm();
                _this.tableList(_this.search.pageNumber);
              })
              .catch((error) => {
                _this.isSubmitting = false;
                console.error("添加车场失败:", error);
              });
          } else {
            _this
              .$putRequest(parkAdd() + "/" + _this.form.id, {
                parentId: _this.form.propertyId,
                parkingId: _this.form.id,
                parkingType: _this.form.type,
                cityId: _this.form.city,
                parkingAddress: _this.form.address,
                parkingName: _this.form.name,
                pointLat: _this.form.latitude,
                pointLng: _this.form.longitude,
                userId: _this.form.manager,
                // chargeRuleId: _this.form.chargeRuleId,
                attr3: _this.form.attr3,
                parkingBusType: _this.form.parkingBusType,
                isShare: _this.form.isShare ? 1 : 0,
                unconsciousPayAuto: _this.form.unconsciousPayAuto,
                attr2: _this.form.attr2,
                floor: _this.form.floor,
                parkingLayer: _this.form.parkingLayer?_this.form.parkingLayer.replace(/，/g, ',') : '',
                /*parkingBusModel:"1",
							parkingDescription:"selfSupport",
							parkingBusType: "1",
							approachNum:0,*/
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.isSubmitting = false;
                  return _this.$layer.msg(data.message);
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.initForm();
                _this.tableList(_this.curIndex);
              })
              .catch((error) => {
                _this.isSubmitting = false;
                console.error("修改车场失败:", error);
              });
          }
        }
      });
    },
    onParkCancleBtn() {
      this.dialogFormVisible = false;
      this.initForm();
    },
    initForm() {
      this.form.id = "";
      this.form.type = "";
      this.form.city = "";
      this.form.county = "";
      this.form.address = "";
      this.form.name = "";
      this.form.latitude = "";
      this.form.longitude = "";
      this.form.pointLng = "";
      this.form.manager = "";
      this.form.parkingBusType = "";
      this.form.propertyId = null;
      this.form.isShare = false;
      this.form.attr2 = "";
      this.form.floor = "";
      this.form.parkingLayer = "";
      this.form.attr3 = "";
      this.form.unconsciousPayAuto = 1;
      this.parkingImageUrl = "";
      this.searchAddress = "";
      this.isSubmitting = false;
      this.imageUploadLoading = false;
      this.uploadProgress = 0;
    },
    delPark: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该车场？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this.$deleteRequest(deletePark() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功",
                title: "成功",
              });
              _this.search.pageNumber = 1;
              _this.tableList(_this.curIndex);
            } else {
              data.status == 233;
              _this.$notify.error({
                message: "该车场下有泊位段，请先删除泊位段！",
                title: "失败",
              });
            }
          });
        }
      );
    },
    // 收费规则
    addrOrEditRuleTrue: function () {
      var _this = this;
      this.$refs["ruleForm"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisibleRule = false;
          if (_this.showPeriod) {
            if (!Boolean(_this.periodRule.chargeId)) {
              _this
                .$postRequest(addOrUpdateChargeRule(), {
                  chargeRuleId: _this.chargeRuldeMode,
                  parkingId: _this.periodRule.parkingId,
                  wdFreeTime: _this.periodRule.freeParking,
                  wdFirstQuota: _this.periodRule.ceiling,
                  wdFirstStartTime: _this.periodRule.beginTime,
                  wdFirstEndTime: _this.periodRule.end,
                  wdFirstHours: _this.periodRule.money1,
                  wdFirstPrice: _this.periodRule.money2,

                  attr1: _this.periodRule.attr1,

                  attr3: _this.periodRule.attr3,

                  attr5: _this.periodRule.periods,
                })
                .then((data) => {
                  if (data.status != 200) return _this.$layer.msg(data.message);
                  _this.$notify({
                    type: "success",
                    title: "成功",
                    message: "收费规则添加成功！",
                  });
                  _this.search.pageNumber = 1;
                  _this.tableList(_this.search.pageNumber);
                });
            } else {
              _this
                .$putRequest(
                  addOrUpdateChargeRule() + "/" + _this.periodRule.chargeId,
                  {
                    chargeRuleId: _this.chargeRuldeMode,
                    parkingId: _this.periodRule.parkingId,
                    wdFreeTime: _this.periodRule.freeParking,
                    wdFirstQuota: _this.periodRule.ceiling,
                    wdFirstStartTime: _this.periodRule.beginTime,
                    wdFirstEndTime: _this.periodRule.end,
                    wdFirstHours: _this.periodRule.money1,
                    wdFirstPrice: _this.periodRule.money2,

                    attr1: _this.periodRule.attr1,

                    attr3: _this.periodRule.attr3,

                    attr5: _this.periodRule.periods,
                  }
                )
                .then((data) => {
                  if (data.status != 200) return _this.$layer.msg(data.message);
                  _this.$notify({
                    type: "success",
                    title: "成功",
                    message: "收费规则修改成功！",
                  });
                  // _this.search.pageNumber = 1;
                  _this.tableList(_this.curIndex);
                });
            }
          }
          if (_this.showTimeAdd) {
            // if (!Boolean(_this.ruleForm.chargeId)) {
            _this
              .$postRequest(addOrUpdateChargeRule(), {
                chargeRuleId: _this.chargeRuldeMode,
                parkingId: _this.ruleForm.parkingId,
                wdFreeTime: _this.ruleForm.freeParking,
                wdFirstQuota: _this.ruleForm.ceiling,
                wdFirstStartTime: _this.ruleForm.beginTime,
                wdFirstEndTime: _this.ruleForm.end,
                wdFirstHours: _this.ruleForm.money1,
                wdFirstPrice: _this.ruleForm.money2,
                wdFirstAfter: _this.ruleForm.money3,
                attr1: _this.ruleForm.attr1,
                attr2: _this.ruleForm.attr2,
                attr3: _this.ruleForm.attr3,
                attr4: _this.ruleForm.attr4,
                attr5: _this.ruleForm.attr5,
                attr6: _this.ruleForm.attr6,
                wdFirstHoursPrice: _this.ruleForm.money4,
                odFreeTime: _this.ruleForm.freeParkingF,
                odFirstQuota: _this.ruleForm.ceilingF,
                odFirstStartTime: _this.ruleForm.beginTimeF,
                odFirstEndTime: _this.ruleForm.endF,
                odFirstHours: _this.ruleForm.moneyF1,
                odFirstPrice: _this.ruleForm.moneyF2,
                odFirstAfter: _this.ruleForm.moneyF3,
                odFirstHoursPrice: _this.ruleForm.moneyF4,
                smallDiscount: strToNumber(_this.ruleForm.smallDiscount),
                smallDiscountHours: strToNumber(
                  _this.ruleForm.smallDiscountHours
                ),
                smallByparkFlag: _this.ruleForm.smallByparkFlag ? "y" : "n",
                bigDiscount: strToNumber(_this.ruleForm.bigDiscount),
                bigDiscountHours: strToNumber(_this.ruleForm.bigDiscountHours),
                bigByparkFlag: _this.ruleForm.bigByparkFlag ? "y" : "n",
                overbigDiscount: strToNumber(_this.ruleForm.overbigDiscount),
                overbigDiscountHours: strToNumber(
                  _this.ruleForm.overbigDiscountHours
                ),
                overbigByparkFlag: _this.ruleForm.overbigByparkFlag ? "y" : "n",
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "收费规则添加成功！",
                });

                _this.tableList(_this.curIndex);
              });
            // }
            // else {
            //   _this
            //     .$putRequest(
            //       addOrUpdateChargeRule() + "/" + _this.ruleForm.chargeId,
            //       {
            //         chargeRuleId: _this.chargeRuldeMode,
            //         parkingId: _this.ruleForm.parkingId,
            //         // chargeRuleId: _this.ruleForm.chargeId,
            //         wdFreeTime: _this.ruleForm.freeParking,
            //         wdFirstQuota: _this.ruleForm.ceiling,
            //         wdFirstStartTime: _this.ruleForm.beginTime,
            //         wdFirstEndTime: _this.ruleForm.end,
            //         wdFirstHours: _this.ruleForm.money1,
            //         wdFirstPrice: _this.ruleForm.money2,
            //         wdFirstAfter: _this.ruleForm.money3,
            //         attr1: _this.ruleForm.attr1,
            //         attr2: _this.ruleForm.attr2,
            //         attr3: _this.ruleForm.attr3,
            //         attr4: _this.ruleForm.attr4,
            //         attr5: _this.ruleForm.attr5,
            //         attr6: _this.ruleForm.attr6,
            //         wdFirstHoursPrice: _this.ruleForm.money4,
            //         odFreeTime: _this.ruleForm.freeParkingF,
            //         odFirstQuota: _this.ruleForm.ceilingF,
            //         odFirstStartTime: _this.ruleForm.beginTimeF,
            //         odFirstEndTime: _this.ruleForm.endF,
            //         odFirstHours: _this.ruleForm.moneyF1,
            //         odFirstPrice: _this.ruleForm.moneyF2,
            //         odFirstAfter: _this.ruleForm.moneyF3,
            //         odFirstHoursPrice: _this.ruleForm.moneyF4,
            //         smallDiscount:strToNumber(_this.ruleForm.smallDiscount),
            //         smallDiscountHours:strToNumber(_this.ruleForm.smallDiscountHours),
            //         smallByparkFlag: _this.ruleForm.smallByparkFlag ? "y" : "n",
            //         bigDiscount:strToNumber(_this.ruleForm.bigDiscount),
            //         bigDiscountHours:strToNumber(_this.ruleForm.bigDiscountHours),
            //         bigByparkFlag: _this.ruleForm.bigByparkFlag ? "y" : "n",
            //         overbigDiscount:strToNumber(_this.ruleForm.overbigDiscount),
            //         overbigDiscountHours:strToNumber(_this.ruleForm.overbigDiscountHours),
            //         overbigByparkFlag: _this.ruleForm.overbigByparkFlag
            //           ? "y"
            //           : "n",
            //       }
            //     )
            //     .then((data) => {
            //       if (data.status != 200) return _this.$layer.msg(data.message);
            //       _this.$notify({
            //         type: "success",
            //         title: "成功",
            //         message: "收费规则修改成功！",
            //       });
            //       // _this.search.pageNumber = 1;
            //       _this.tableList(_this.curIndex);
            //     });
            // }
          }
          if (_this.showTimeQuantum) {
            _this
              .$postRequest(addOrUpdateChargeRuleByTimeQuantum(), {
                chargeRuleId: _this.chargeRuldeMode,
                params: [
                  {
                    parkingId: _this.formRuleOne.parkingId,
                    carType: _this.formRuleOne.params[0].carType,
                    lrId: _this.formRuleOne.params[0].lrId,
                    // wdStartTime:
                    //   _this.formRuleOne.params[0].wdStartOrEndTime[0],
                    // wdEndTime: _this.formRuleOne.params[0].wdStartOrEndTime[1],
                    wdStartTime: _this.ruleForm.wdStartOrEndTime,
                    wdEndTime: _this.ruleForm.wdStartOrEndTimeEnd,
                    wdAfterHourF: _this.formRuleOne.params[0].wdAfterHourF,
                    wdFirstHour: _this.formRuleOne.params[0].wdAfterHourF,
                    wdAfterHourL: _this.formRuleOne.params[0].wdLastHour,
                    wdLastHour: _this.formRuleOne.params[0].wdLastHour,
                    wdFirstPrice: _this.formRuleOne.params[0].wdFirstPrice,
                    wdAfterPrice: _this.formRuleOne.params[0].wdAfterPrice,
                    wdLastPrice: _this.formRuleOne.params[0].wdLastPrice,
                    wdFreeMin: _this.formRuleOne.freeTime,
                    // odStartTime:
                    //   _this.formRuleOne.params[0].odStartOrEndTime[0],
                    // odEndTime: _this.formRuleOne.params[0].odStartOrEndTime[1],
                    odStartTime: _this.ruleForm.odStartOrEndTime,
                    odEndTime: _this.ruleForm.odStartOrEndTimeEnd,
                    odAfterHourF: _this.formRuleOne.params[0].odAfterHourF,
                    odFirstHour: _this.formRuleOne.params[0].odAfterHourF,
                    odAfterHourL: _this.formRuleOne.params[0].odLastHour,
                    odLastHour: _this.formRuleOne.params[0].odLastHour,
                    odFirstPrice: _this.formRuleOne.params[0].odFirstPrice,
                    odAfterPrice: _this.formRuleOne.params[0].odAfterPrice,
                    odLastPrice: _this.formRuleOne.params[0].odLastPrice,
                    odFreeMin: _this.formRuleOne.freeTime,
                  },
                ],
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "收费规则修改成功!",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          }
        }
      });
    },

    //打开收费规则窗口
    getChargeRule: function (parkingId, objCharge) {
      this.dialogFormVisibleRule = true;
      this.ruleForm.parkingId = parkingId;
      this.formRuleOne.parkingId = parkingId;

      if (objCharge) {
        var chargeRuleId = JSON.parse(objCharge)?.id;
        this.chargeRuldeMode = chargeRuleId;
        //按时累加
        if (chargeRuleId == "4") {
          this.ruleForm.chargeId = chargeRuleId;

          this.showTimeAdd = true;
          this.showTimeQuantum = false;
          this.showPeriod = false;
          this.$postRequest(getChargeRule(), {
            parkingId: parkingId,
            // chargeRuleId: charge.id,
          }).then((data) => {
            if (data?.status != 200) return;
            this.ruleForm.freeParking = data.data.wdFreeTime;
            this.ruleForm.ceiling = data.data.wdFirstQuota;
            this.ruleForm.beginTime = data.data.wdFirstStartTime;
            this.ruleForm.end = data.data.wdFirstEndTime;
            this.ruleForm.money1 = data.data.wdFirstHours;
            this.ruleForm.money2 = data.data.wdFirstPrice;
            this.ruleForm.money3 = data.data.wdFirstAfter;
            this.ruleForm.money4 = data.data.wdFirstHoursPrice;
            this.ruleForm.attr1 = data.data.attr1;
            this.ruleForm.attr2 = data.data.attr2;
            this.ruleForm.attr3 = data.data.attr3;
            this.ruleForm.attr4 = data.data.attr4;
            this.ruleForm.attr5 = data.data.attr5;
            this.ruleForm.attr6 = data.data.attr6;
            this.ruleForm.freeParkingF = data.data.odFreeTime;
            this.ruleForm.ceilingF = data.data.odFirstQuota;
            this.ruleForm.beginTimeF = data.data.odFirstStartTime;
            this.ruleForm.endF = data.data.odFirstEndTime;
            this.ruleForm.moneyF1 = data.data.odFirstHours;
            this.ruleForm.moneyF2 = data.data.odFirstPrice;
            this.ruleForm.moneyF3 = data.data.odFirstAfter;
            this.ruleForm.moneyF4 = data.data.odFirstHoursPrice;
            this.ruleForm.smallDiscount = data?.data?.smallDiscount ?? "";
            this.ruleForm.smallDiscountHours =
              data?.data?.smallDiscountHours ?? "";
            this.ruleForm.smallByparkFlag =
              data?.data?.smallByparkFlag === "y" ? true : false;
            this.ruleForm.bigDiscount = data?.data?.bigDiscount ?? "";
            this.ruleForm.bigDiscountHours = data?.data?.bigDiscountHours ?? "";
            this.ruleForm.bigByparkFlag =
              data?.data?.bigByparkFlag === "y" ? true : false;
            this.ruleForm.overbigDiscount = data?.data?.overbigDiscount ?? "";
            this.ruleForm.overbigDiscountHours =
              data?.data?.overbigDiscountHours ?? "";
            this.ruleForm.overbigByparkFlag =
              data?.data?.overbigByparkFlag === "y" ? true : false;
          });
        }
        //按工作日/非工作日
        if (chargeRuleId == "1") {
          this.showTimeAdd = false;
          this.showTimeQuantum = true;
          this.showPeriod = false;
          this.formRuleOne.chargeId = chargeRuleId;
          this.$get(getChargeRuleByTimeQuantum(), {
            parkingId: parkingId,
            chargeRuleId: chargeRuleId,
          }).then((data) => {
            if (data.status != 200) return;
            var result = data.data;
            for (var i = 0; i < result.length; i++) {
              if (result[i].carType == "auto") {
                this.formRuleOne.freeTime = result[i].wdFreeMin;

                for (var k in result[i]) {
                  this.formRuleOne.params[0][k] = result[i][k];
                }

                // this.formRuleOne.params[0].wdStartOrEndTime = [
                //   result[i].wdStartTime,
                //   result[i].wdEndTime
                // ];
                this.ruleForm.wdStartOrEndTime = result[i].wdStartTime;
                this.ruleForm.wdStartOrEndTimeEnd = result[i].wdEndTime;

                // this.formRuleOne.params[0].odStartOrEndTime = [
                //   result[i].odStartTime,
                //   result[i].odEndTime
                // ];
                this.ruleForm.odStartOrEndTime = result[i].odStartTime;
                this.ruleForm.odStartOrEndTimeEnd = result[i].odEndTime;
              }
            }
          });
        }

        if (chargeRuleId == 2) {
          this.periodRule.chargeId = chargeRuleId;
          this.periodRule.parkingId = parkingId;
          this.showPeriod = true;
          this.showTimeAdd = false;
          this.showTimeQuantum = false;
          this.$postRequest(getChargeRule(), {
            parkingId: parkingId,
            // chargeRuleId: charge.id,
          }).then((data) => {
            if (data.status != 200) return;

            this.periodRule.freeParking = data.data.wdFreeTime;
            this.periodRule.ceiling = data.data.wdFirstQuota;
            this.periodRule.beginTime = data.data.wdFirstStartTime;
            this.periodRule.end = data.data.wdFirstEndTime;
            this.periodRule.money1 = data.data.wdFirstHours;
            this.periodRule.money2 = data.data.wdFirstPrice;
            this.periodRule.attr1 = data.data.attr1;
            this.periodRule.attr3 = data.data.attr3;
            this.periodRule.periods = data.data.attr5;
          });
        }
      } else {
      }
    },
    openDialogRule: function () {
      this.getAllChargeRuleType();
    },

    closeDialogParking: function () {
      // 重置表单验证
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }

      this.imageUploadLoading = false;
      this.uploadProgress = 0;
      
      // 清理地图实例
      if (this.map) {
        try {
          // 清除所有覆盖物
          const overlays = this.map.getOverlays ? this.map.getOverlays() : [];
          overlays.forEach(overlay => {
            try {
              if (this.map.removeOverlay) {
                this.map.removeOverlay(overlay);
              } else if (this.map.removeLayer) {
                this.map.removeLayer(overlay);
              }
            } catch (e) {
              console.warn("移除覆盖物失败:", e);
            }
          });
          
          // 移除地图事件监听器（如果可能）
          if (typeof this.map.removeEventListener === 'function') {
            // 注意：天地图可能不支持移除事件监听器，这里只是尝试
            try {
              this.map.removeEventListener("click");
            } catch (e) {
              // 忽略错误
            }
          }
          
          // 销毁地图实例（如果支持）
          if (typeof this.map.destroy === 'function') {
            try {
              this.map.destroy();
            } catch (e) {
              console.warn("销毁地图失败:", e);
            }
          }
        } catch (e) {
          console.warn("清理地图失败:", e);
        }
        this.map = null;
      }
      
      // 清空地图容器（确保下次打开时是干净的）
      const mapContainer = document.getElementById("areaMap");
      if (mapContainer) {
        mapContainer.innerHTML = "";
      }
    },

    closeDialogRule: function () {
      this.chargeRuldeMode = "4";
      //按时累计
      this.ruleForm.chargeRuleId = "";
      this.ruleForm.parkingId = "";
      this.ruleForm.freeParking = "";
      this.ruleForm.ceiling = "";
      this.ruleForm.beginTime = "";
      this.ruleForm.end = "";
      this.ruleForm.money1 = "";
      this.ruleForm.money2 = "";
      this.ruleForm.money3 = "";
      this.ruleForm.money4 = "";
      this.ruleForm.freeParkingF = "";
      this.ruleForm.ceilingF = "";
      this.ruleForm.beginTimeF = "";
      this.ruleForm.endF = "";
      this.ruleForm.moneyF1 = "";
      this.ruleForm.moneyF2 = "";
      this.ruleForm.moneyF3 = "";
      this.ruleForm.moneyF4 = "";
      this.ruleForm.attr1 = "";
      this.ruleForm.attr2 = "";
      this.ruleForm.attr3 = "";
      this.ruleForm.attr4 = "";
      this.ruleForm.attr5 = "";
      this.ruleForm.attr6 = "";
      this.smallDiscount = "";
      this.smallDiscountHours = "";
      this.smallByparkFlag = false;
      this.bigDiscount = "";
      this.bigDiscountHours = "";
      this.bigByparkFlag = false;
      this.overbigDiscount = "";
      this.overbigDiscountHours = "";
      this.overbigByparkFlag = false;
      //按时间段
      this.formRuleOne = {
        chargeRuleId: "",
        parkingId: "",
        freeTime: "",
        params: [
          {
            lrId: "",
            carType: "auto",
            wdStartOrEndTime: ["", ""],
            wdAfterHourF: "",
            wdLastHour: "",
            wdFirstPrice: "",
            wdAfterPrice: "",
            wdLastPrice: "",
            wdFreeMin: "",
            odStartOrEndTime: ["", ""],
            odAfterHourF: "",
            odLastHour: "",

            odFirstPrice: "",
            odAfterPrice: "",
            odLastPrice: "",
            odFreeMin: "",
          },
        ],
      };
    },

    showName(v) {
      // console.log(v)
    },
    parkingTypeList() {
      this.$get(getParkingType()).then((data) => {
        console.log(data);
      });
    },
    generateActivationCode(id) {
      this.activationCodeDialogVisible = true;
      this.activationCodeForm.parkingId = id;
    },
    generateActivationCodeTrue() {
      this.activationCodeDialogVisible = false;
      this.$postRequest(getGenerateActivationCode(), {
        parkingId: this.activationCodeForm.parkingId,
        udId: this.activationCodeForm.udId,
        type: this.activationCodeForm.type,
        begindate: this.activationCodeForm.begindate,
        enddate: this.activationCodeForm.enddate,
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        this.$notify({
          type: "success",
          title: "成功",
          message: "激活码生成成功！",
        });
        this.viewActivationCodeDialogVisible = true;
      });
    },
    viewActivationCodeList() {
      this.$get(getActivationCodeList(), {
        parkingId: this.activationCodeForm.parkingId,
        limit: 0,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.activationCodeData = data.data.rows;
      });
    },
    viewActivationCode(id) {
      this.activationCodeForm.parkingId = id;
      this.viewActivationCodeDialogVisible = true;
    },
    codeDownload(id, name) {
      this.codeDownloadData.chargeUserId = "";
      this.getAllChargeUsers();
      this.outerCodeDialogVisible = true;
      // this.codeDialogVisible=true;
      this.codeDownloadData.parkingId = id;
      this.codeDownloadData.parkingName = name;
    },
    qrcode(id, chargeUserId, w, h) {
      let qrcode = new QRCode("qrcode", {
        width: w,
        height: h,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      // qrcode.makeCode(`http://bosk88.natapp1.cc/pay/sweepCodePayment/onSite?parkingId=${id}`)
      qrcode.makeCode(
        `${this.$codeUrl}/pay/sweepCodePayment/onSite?parkingId=${id}&chargeId=${chargeUserId}`
      ); //生成另一个新的二维码
      // qrcode.makeCode(`http://wo100.natapp1.cc/pay/sweepCodePayment/onSite?parkingId=${id}`) //生成另一个新的二维码
    },
    downloadQrcode(w, h) {
      document.getElementById("qrcode").innerHTML = "";
      var id = this.codeDownloadData.parkingId;
      var name = this.codeDownloadData.parkingName;
      var chargeUser = this.codeDownloadData.chargeUserId;
      this.qrcode(id, chargeUser, w, h);
      setTimeout(function () {
        var qrcode = document.getElementById("qrcode");
        var img = qrcode.getElementsByTagName("img")[0];
        var link = document.createElement("a");
        var url = img.getAttribute("src");
        link.setAttribute("href", url);
        link.setAttribute("download", `${name}(${w}).png`);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }, 1);
    },
    payBind(id, paymentChannel) {
      this.$get(getAllPayType()).then((data) => {
        this.payTypeDialogVisible = true;
        this.allPayTypeData = data.data.rows;
      });
      this.payTypeForm.payType = paymentChannel;
      this.payTypeForm.parkingId = id;
    },
    payBindTrue() {
      this.payTypeDialogVisible = false;
      this.$putRequest(addOrEdit() + "/" + this.payTypeForm.parkingId, {
        parkingId: this.payTypeForm.parkingId,
        paymentChannel: this.payTypeForm.payType,
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          type: "success",
          title: "成功",
          message: "支付绑定成功！",
        });
        this.tableList(this.curIndex); //
      });
    },
    getActivationCodeType(value) {
      if (value == 1) {
        this.dateView = false;
      } else {
        this.dateView = true;
      }
    },
    hasPayConfigure(paymentChannel) {
      this.$get(getPayConfigure(), {
        parkingId: this.payTypeForm.parkingId,
        paymentChannel: paymentChannel,
      }).then((data) => {
        if (data.status == 400) {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    getAllChargeUsers: function () {
      var _this = this;
      this.$get(chargeUserList() + "?isDeleted=0", {
        limit: 0,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        _this.allChargeUserData = data.data.rows;
        // _this.tableListData=data.data;
      });
    },
    selectedChargerUser() {
      this.outerCodeDialogVisible = false;
      this.codeDialogVisible = true;
    },
    getAllChargeRuleType() {
      this.$get(requestAllChargeRuleType()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.allChargeRuleTypeData = data.data.rows;
      });
    },
    getChargeRuleMode(v) {
      if (v == "4") {
        this.showTimeAdd = true;
        this.showTimeQuantum = false;
        this.showPeriod = false;
      }
      if (v == "1") {
        this.showTimeAdd = false;
        this.showTimeQuantum = true;
        this.showPeriod = false;
      }
      if (v == "2") {
        this.showTimeAdd = false;
        this.showTimeQuantum = false;
        this.showPeriod = true;
      }
    },
    startInvoice(parkingId) {
      //console.log(event.target.checked)
    },
    getBaseConfigure() {
      this.$get(requestParkingBaseConfig()).then((data) => {
        if (data.status != 200) return;
        this.baseConfigureData = data.data.rows;
      });
    },
    openConfigureDialog() {},
    closeConfigureDialog() {
      this.configureForm.parkingId = "";
      this.configureForm.code = [];
    },
    configure(id) {
      this.configureForm.parkingId = id;
      this.oneConfigure(id);
      this.dialogConfigureVisible = true;
    },
    clickItemConfigure(item, dd) {
      let data = [];
      if (dd == "open") {
        data = this.configureData.map(function (val, index, array) {
          if (item.value == val.value) {
            val.isOpen = true;
            val.isClose = false;
          }
          return val;
        });
        this.configureForm.code.push(item.value);
      }
      if (dd == "close") {
        data = this.configureData.map(function (val, index, array) {
          if (item.value == val.value) {
            val.isOpen = false;
            val.isClose = true;
          }
          return val;
        });
      }
      this.configureData = data;
    },
    oneConfigure(id) {
      var _this = this;
      this.$get(getOneParkingConfigure(), {
        parkingId: id,
      }).then((data) => {
        if (data.status != 200) return;
        let dd = data.data;
        let dds = this.baseConfigureData;
        if (dd.length > 0) {
          this.configureData = dds.map(function (val, index, array) {
            let itemFind = dd.find((item) => val.value === item.configValue);
            if (itemFind) {
              val.isOpen = true;
              val.isClose = false;
            } else {
              val.isOpen = false;
              val.isClose = true;
            }
            return val;
          });
        } else {
          this.configureData = dds.map(function (val, index, array) {
            val.isOpen = false;
            val.isClose = true;
            return val;
          });
        }
      });
    },
    configureOneConfigure() {
      this.dialogConfigureVisible = false;
      let codes = [];
      for (let item of this.configureData) {
        if (item.isOpen) {
          codes.push(item.value);
        }
      }
      this.$postRequest(requestConfigureOneParkingConfigure(), {
        parkingId: this.configureForm.parkingId,
        values: codes,
      }).then((data) => {
        if (data.status != 200) {
          this.$notify.error({
            type: "success",
            message: data.message,
            title: "失败",
          });
          return;
        }
        this.$notify({
          type: "success",
          message: "配置成功！",
          title: "成功",
        });
      });
    },
    chargeLower() {
      alert("下发成功");
    },
    onRuleAddClick() {
      this.periodRule = {
        ...this.periodRule,
        periods: [
          ...this.periodRule.periods,
          {
            id: Math.random().toString(16).slice(2),
            exceed: "",
            every: "",
            car: "",
            cart: "",
            superCar: "",
          },
        ],
      };
    },
    onRuleReduceClick(id) {
      if (this.periodRule.periods.length <= 1) return;
      const periods = this.periodRule.periods.filter(
        (period) => period.id !== id
      );
      this.periodRule = {
        ...this.periodRule,
        periods: [...periods],
      };
    },
    searchMapAddress() {
      if (!this.searchAddress || !this.searchAddress.trim()) {
        this.$message.warning("请输入要搜索的地址");
        return;
      }
      
      if (!this.map) {
        this.$message.warning("地图未初始化，请稍候再试");
        return;
      }
      
      var _this = this;
      
      // 显示加载提示
      const loading = this.$loading({
        lock: true,
        text: '正在搜索地址...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 使用天地图API进行地址解析
      geocodeAddress(this.searchAddress.trim(), function (result) {
        loading.close();
        
        if (result && result.lng && result.lat) {
          console.log("搜索地址结果:", result);
          
          // 设置地图中心点并添加标记
          setMapCenter(_this.map, result.lng, result.lat, 16);
          addMapOverlayl(result.lat, result.lng, _this.map);
          
          // 更新表单数据
          _this.form.longitude = result.lng;
          _this.form.latitude = result.lat;
          
          // 优先使用返回的地址，如果没有则使用搜索的地址
          const address = result.address || _this.searchAddress;
          _this.form.address = address;
          _this.searchAddress = address;
          
          _this.$message.success("地址定位成功");
        } else {
          _this.$message.error("未能找到该地址，请检查地址是否正确或重新输入");
        }
      });
    },

    // 车场图片上传相关方法
    validateParkingImage(file) {
      const isImage = file.type.startsWith("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("只能上传图片文件!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },

    handleParkingImageSuccess(res, file) {
      console.log("图片上传成功:", res);
      this.uploadProgress = 100;
      if (res?.status === 200) {
        this.form.attr3 = res.data;
        this.parkingImageUrl = URL.createObjectURL(file.raw);
        this.$message.success("图片上传成功");

        // 延迟重置进度条
        setTimeout(() => {
          this.uploadProgress = 0;
        }, 1000);
      } else {
        this.$message.error("图片上传失败,请重新上传");
      }
    },

    handleParkingImageError(err, file) {
      this.imageUploadLoading = false;
      this.uploadProgress = 0;
      this.$message.error("图片上传失败");
    },

    beforeParkingImageUpload(file) {
      if (!this.validateParkingImage(file.raw)) return false;
      this.uploadProgress = 0;

      // 读取文件并预览
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.parkingImageUrl = event.target.result;
        };
        reader.readAsDataURL(file.raw);
      } else {
        this.$message.error("您的浏览器不支持 FileReader");

        return false;
      }

      // 允许自动上传，因为现在有真实的进度回调
      return true;
    },

    // 处理上传进度
    handleUploadProgress(event, file, fileList) {
      // event.percent: 上传进度百分比 (0-100)
      // file: 当前上传的文件对象
      // fileList: 文件列表

      console.log("上传进度:", event.percent + "%", "文件:", file.name);

      // 更新进度状态
      this.uploadProgress = Math.round(event.percent);

      // 如果进度达到100%，可以做一些处理
      if (event.percent >= 100) {
        this.uploadProgress = 100;
        // 延迟重置进度条
        setTimeout(() => {
          this.uploadProgress = 0;
        }, 1000);
      }
    },

    // 移除车场图片
    removeParkingImage() {
      this.$confirm("确定要移除当前图片吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.form.attr3 = "";
          this.parkingImageUrl = "";
          this.uploadProgress = 0;

          // 重置上传组件
          if (this.$refs.parkingImageUpload) {
            this.$refs.parkingImageUpload.clearFiles();
          }

          this.$message.success("图片已移除");
        })
        .catch(() => {
          // 用户取消操作
        });
    },

    // 预览车场图片
    previewParkingImage(imageUrl) {
      if (!imageUrl) return;

      // 使用Element UI的图片预览组件
      this.$alert(
        `<div class="image-preview-content">
           <img src="${imageUrl}" class="preview-image" alt="车场图片" />
           <div class="image-info">
             <p><i class="el-icon-picture"></i> 车场图片预览</p>
             <p class="image-url">${imageUrl}</p>
           </div>
         </div>`,
        "车场图片预览",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "关闭",
          customClass: "parking-image-preview-dialog",
          showCancelButton: false,
          center: true,
        }
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    ...mapState({ proprety: (state) => state.parking.property }),
    permiss() {
      this.parklist_btn_add = this.elements["parklist:btn_add"];
      this.parklist_btn_rule = this.elements["parklist:btn_rule"];
      this.parklist_btn_pkset = this.elements["parklist:btn_pkset"];
      this.parklist_btn_control = this.elements["parklist:btn_control"];
      this.parklist_btn_person = this.elements["parklist:btn_person"];
      this.parkset_btn_edit = this.elements["parklist:btn_edit"];
      this.parklist_btn_remove = this.elements["parklist:btn_remove"];
      //console.log("parklist_btn_remove")
      //console.log(this.parklist_btn_remove)
    },
  },
  components: {
    Page,

    Refresh,
    AllTree,
  },

  created: function () {
    this.permiss;
    this.getParkingBusType();
    this.getParkType();
    this.getCity();
    this.getRulesType();
  },
  mounted: function () {
    this.getBaseConfigure();
    this.getAllProperty();
    this.tableList();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;
  /* height:65px; */
  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
/* .el-form-item{
margin-bottom: 14px;
} */
.size {
  color: red;
  border-bottom: #ddd solid 1px;
  margin-bottom: 3px;

  font-weight: bold;
}
#qrcode {
  display: none;
}
.columns {
  display: flex;
  justify-content: flex-start;
}
.column-last {
  justify-content: center;
}
/* .position {
margin-left: 92px;
margin-top: -17px;
} */
.gap {
  height: 1px;
  width: 100%;
  background: #ddd;
  margin-bottom: 20px;
}
.discount {
  display: flex;
  justify-content: baseline;
  align-items: center;
}

.car-discount .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.discount-tip {
  margin-left: 10px;
}
</style>
<style>
.parklist .chargerule-mode .el-form-item__label {
  text-align: left !important;
  color: red;
  font-weight: bold;
  width: 80px !important;
}
.column-last .el-form-item:first-child {
  display: flex;
  justify-content: center;
}
.column-last .el-form-item:first-child .el-form-item__content {
  margin-left: 0 !important;
}
.parklist .chargerule-mode .el-form-item__content {
  margin-left: 80px !important;
}
.parklist .chargerule-mode .el-input {
  border: 1px solid red;
  border-radius: 5px;
}
.parklist .chargerule-mode .el-select .el-input.is-focus .el-input__inner {
  border: none !important;
}
.parklist .chargerule-mode .el-select .el-input__inner:focus {
  border: none !important;
}
.parklist .chargerule-mode .el-input__inner {
  border: none !important;
}
.parklist .chargerule-mode .el-icon-arrow-up:before {
  color: red;
}
.parklist .columns .el-input {
  width: 80px;
}
.parklist .el-input__inner {
  border-radius: 5px 0 0 5px !important;
}
.parklist .el-dialog__body {
  display: flex !important;
  justify-content: flex-start !important;
}
/* .parklist .columns .el-form-item:first-child {
width: 55%;
} */
/* .parklist .columns .el-form-item:last-child {
width: 45%;
} */
.parklist .columns-others .el-form-item {
  width: 100% !important;
}
.parklist .period-group {
  border: 1px dashed #ddd;
  border-radius: 20px;
  padding: 20px;
  box-sizing: border-box;
}
.add .el-icon-circle-plus-outline {
  color: #409eff;
  font-size: 50px;
}
.add {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}
</style>
<style>
.limit .limit-tip .el-form-item__label {
  width: 130px !important;
}
.parklist .el-form-item__content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.parklist .el-dialog__body {
  height: auto;
  max-height: none;
}
.parking-dialog-form .el-select,
.parking-dialog-form .el-input {
  width: 100% !important;
}

/* 车场图片上传样式 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  display: block;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.upload-tip-below {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  text-align: center;
  line-height: 1.4;
  padding: 0 10px;
}

/* 优化后的弹窗布局样式 */
.parking-dialog-content {
  display: flex;
  gap: 24px;
  min-height: 600px;
}

.form-section {
  flex: 1;
  min-width: 0;
}

.map-section {
  flex: 1;
  min-width: 0;
}

.section-title {
  margin: 0 0 20px 0;
  padding: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  border-bottom: 2px solid #409eff;
  position: relative;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 40px;
  height: 2px;
  background: #409eff;
}

.form-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 13px;
}

.form-tip i {
  font-size: 16px;
  color: #1890ff;
}

.required {
  color: #f56c6c;
  font-weight: bold;
}

.parking-form {
  padding: 0;
}

.parking-form .el-form-item {
  margin-bottom: 20px;
}

.parking-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
  line-height: 1.4;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-item-half {
  flex: 1;
  min-width: 0;
}

.form-item-half .el-form-item__content {
  width: 100%;
}

.full-width-item {
  width: 100%;
}

.full-width-item .el-form-item__content {
  width: 100%;
}

.checkbox-item-inline {
  margin: 0;
  display: flex;
  align-items: center;
}

.checkbox-label {
  font-weight: 500;
  color: #606266;
  margin-left: 8px;
}

.payment-checkbox {
  display: flex;
  align-items: center;
  padding: 8px 6px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.payment-checkbox:hover {
  background: #e9ecef;
  border-color: #409eff;
}

.payment-icon {
  font-size: 16px;
  color: #409eff;
  margin-right: 8px;
}

.share-section {
  margin-bottom: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.share-section:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
}

.share-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
}

.share-checkbox {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.share-icon {
  font-size: 16px;
  color: #409eff;
}

.share-label {
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.share-content {
  padding: 20px;
  background: #fff;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.share-type-item {
  margin-bottom: 0;
}

.share-type-item .el-form-item__label {
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
}

.map-container {
  display: flex;
  flex-direction: column;
}

.address-search {
  margin-top: 10px;
  margin-bottom: 0;
}

.search-input {
  width: 100%;
}

.search-input .el-input__inner {
  border-radius: 6px 0 0 6px;
}

.search-input .el-input-group__append {
  border-radius: 0 6px 6px 0;
  background: #409eff;
  border-color: #409eff;
  color: white;
}

.search-input .el-input-group__append:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.map-content {
  width: 100%;
  height: 400px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.map-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 13px;
}

.map-tip i {
  font-size: 16px;
  color: #1890ff;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .parking-dialog-content {
    flex-direction: column;
    gap: 20px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .form-item-half {
    margin-bottom: 20px;
  }

  .share-section {
    margin-bottom: 16px;
  }

  .share-header {
    padding: 14px 16px;
  }

  .share-content {
    padding: 16px;
  }

  .payment-checkbox {
    padding: 6px 10px;
  }
}

@media (max-width: 768px) {
  .parking-dialog-form .el-dialog {
    width: 95% !important;
    margin: 5vh auto !important;
  }

  .parking-dialog-content {
    gap: 16px;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 16px;
  }

  .form-tip,
  .map-tip {
    font-size: 12px;
    padding: 10px 12px;
  }

  .share-section {
    margin-bottom: 12px;
  }

  .payment-checkbox {
    padding: 6px 8px;
  }

  .map-content {
    height: 300px;
  }

  .avatar-uploader .el-upload {
    width: 120px;
    height: 120px;
  }

  .avatar-uploader-icon {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  .avatar {
    width: 120px;
    height: 120px;
  }

  .upload-tip-below {
    font-size: 11px;
    margin-top: 6px;
  }

  /* 移动端按钮样式优化 */
  .preview-image-btn {
    min-width: 65px;
    height: 26px;
    font-size: 11px;
    background: #409eff;
    border-radius: 13px;
  }

  .preview-image-btn .el-icon-picture {
    font-size: 11px;
    margin-right: 3px;
  }

  /* 移动端漂浮移除按钮优化 */
  .floating-remove-btn {
    top: -6px;
    right: -6px;
  }

  .remove-btn-circle {
    width: 20px;
    height: 20px;
  }
}

/* 表单控件样式优化 */
.parking-form .el-select,
.parking-form .el-input {
  width: 100%;
}

.parking-form .el-select .el-input__inner,
.parking-form .el-input__inner {
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
}

.parking-form .el-select .el-input__inner:focus,
.parking-form .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.parking-form .el-select:hover .el-input__inner,
.parking-form .el-input:hover .el-input__inner {
  border-color: #c0c4cc;
}

/* 表单控件悬停效果 */
.parking-form .el-form-item:hover .el-form-item__label {
  color: #409eff;
}

.parking-form .el-select:hover .el-input__suffix,
.parking-form .el-input:hover .el-input__suffix {
  color: #409eff;
}

/* 图片上传区域悬停效果 */
.avatar-uploader:hover .el-upload {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 图片上传容器样式 */
.image-upload-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.upload-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

/* 图片与移除按钮容器 */
.image-with-remove {
  position: relative;
  display: inline-block;
}

/* 漂浮的移除按钮 */
.floating-remove-btn {
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 10;
}

.remove-btn-circle {
  display: flex;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.remove-btn-circle:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.remove-btn-circle:active {
  transform: scale(0.95);
}

/* 上传loading遮罩层 */
.upload-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  z-index: 10;
}

.upload-loading-overlay i {
  font-size: 24px;
  color: #409eff;
  margin-bottom: 8px;
  animation: rotate 1s linear infinite;
}

.upload-loading-overlay span {
  font-size: 12px;
  color: #606266;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 上传进度条样式 */
.upload-progress {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.upload-progress .el-progress {
  flex: 1;
}

.progress-text {
  font-size: 12px;
  color: #409eff;
  font-weight: 500;
  min-width: 35px;
  text-align: right;
}

/* 上传区域禁用状态 */
.avatar-uploader.is-disabled .el-upload {
  cursor: not-allowed;
  opacity: 0.6;
}

.avatar-uploader.is-disabled .el-upload:hover {
  border-color: #d9d9d9;
  box-shadow: none;
}

/* 地图容器悬停效果 */
.map-content:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

/* 弹窗整体样式优化 */
.parking-dialog-form .el-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: dialogSlideIn 0.3s ease-out;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.parking-dialog-form .el-dialog__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid #dee2e6;
  padding: 20px 24px;
}

.parking-dialog-form .el-dialog__body {
  padding: 24px;
  background: #fff;
}

.parking-dialog-form .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.parking-dialog-form .el-dialog__headerbtn {
  top: 20px;
  right: 24px;
}

.parking-dialog-form .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
  color: #909399;
  transition: all 0.3s ease;
}

.parking-dialog-form .el-dialog__headerbtn .el-dialog__close:hover {
  color: #409eff;
  transform: rotate(90deg);
}

/* Footer样式优化 */
.dialog-footer {
  text-align: center;
  padding: 20px 0 0 0;
  border-top: 1px solid #e4e7ed;
  margin-top: 20px;
}

.dialog-footer .el-button {
  min-width: 100px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  margin: 0 8px;
}

.dialog-footer .el-button--primary {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.dialog-footer .el-button--primary:hover {
  background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  transform: translateY(-1px);
}

.dialog-footer .el-button--default {
  border: 1px solid #dcdfe6;
  color: #606266;
  background: #fff;
}

.dialog-footer .el-button--default:hover {
  border-color: #c0c4cc;
  color: #409eff;
  background: #f5f7fa;
}

/* 表格中的车场图片按钮样式 */
.image-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #409eff;
  border-radius: 4px;
}

.preview-image-btn {
  min-width: 70px;
  height: 28px;
  font-size: 12px;
  border-radius: 14px;
  transition: all 0.3s ease;
  background: #409eff;
  border: none;
  color: white;
}

.preview-image-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  background: #66b1ff;
}

.preview-image-btn:active {
  transform: translateY(0);
}

.preview-image-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.3);
}

.preview-image-btn .el-icon-picture {
  margin-right: 4px;
  font-size: 14px;
  transition: transform 0.2s ease;
}

.preview-image-btn:hover .el-icon-picture {
  transform: scale(1.05);
}

.no-image {
  color: #999;
  font-size: 12px;
}

/* 图片预览对话框样式 */
.parking-image-preview-dialog .el-message-box__content {
  padding: 20px;
}

.parking-image-preview-dialog .el-message-box__message {
  padding: 0;
}

/* 图片预览内容样式 */
.image-preview-content {
  text-align: center;
}

.preview-image {
  max-width: 100%;
  max-height: 400px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
}

.image-info {
  text-align: left;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.image-info p {
  margin: 0 0 8px 0;
  color: #606266;
  font-size: 13px;
}

.image-info p:last-child {
  margin-bottom: 0;
}

.image-info .el-icon-picture {
  color: #409eff;
  margin-right: 6px;
}

.image-url {
  color: #909399 !important;
  font-size: 12px !important;
  word-break: break-all;
  line-height: 1.4;
}
.parklist .el-input-group .el-input__inner {
  display: inline-block;
  width: 88%;
}
.parklist .el-input-group__append {
  display: inline-block;
  width: 10%;
  height: auto !important;
}
.parklist .el-button {
  /* padding-left: 10px; */
  padding-right: 10px;
}

/* 移除图片按钮样式（保留备用） */
.remove-image-btn {
  border-radius: 20px;
  transition: all 0.3s ease;
  min-width: 100px;
}

.remove-image-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
}

.remove-image-btn:active {
  transform: translateY(0);
}

.remove-image-btn .el-icon-delete {
  margin-right: 4px;
}

/* 优化漂浮移除按钮样式 */
.floating-remove-btn .el-button--danger {
  background: #f56c6c;
  border-color: #f56c6c;
}

.floating-remove-btn .el-button--danger:hover {
  background: #f78989;
  border-color: #f78989;
}

.floating-remove-btn .el-button--danger:focus {
  background: #f56c6c;
  border-color: #f56c6c;
}

.floating-remove-btn .el-button--danger.is-disabled {
  background: #c0c4cc;
  border-color: #c0c4cc;
  color: #fff;
}
</style>
